import React, { useState, useCallback } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE', accentDark:'#2E8B47',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 pink:'#E91E63', pinkBg:'#FCE4EC',
 orange:'#E05A00', orangeBg:'#FEF0E6',
 dark:'#0F1E14', dark2:'#1A3A22',
};
const inr = n => '₹'+Number(Math.round(n)||0).toLocaleString('en-IN');
const today = new Date().toISOString().slice(0,10);
const fmtDate = d => d?new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'}):'—';

// ── VENUES ────────────────────────────────────────────────────────────────────
const DEFAULT_VENUES = [
 {id:'v1',name:'Pilkhan Garden', capacity:500,type:'Outdoor',color:C.accent, bg:C.accentLight},
 {id:'v2',name:'Bonsai Garden', capacity:150,type:'Outdoor',color:C.teal, bg:C.tealBg},
 {id:'v3',name:'Conference Room', capacity:80, type:'Indoor', color:C.blue, bg:C.blueBg},
 {id:'v4',name:'Petunia Hall', capacity:300,type:'Indoor', color:C.pink, bg:C.pinkBg},
 {id:'v5',name:'Sports Ground', capacity:400,type:'Outdoor',color:C.amber, bg:C.amberBg},
 {id:'v6',name:'Adventure Garden', capacity:200,type:'Outdoor',color:C.orange, bg:C.orangeBg},
 {id:'v7',name:'Lawn Area', capacity:600,type:'Outdoor',color:'#558B2F', bg:'#EBF5E0'},
 {id:'v8',name:'Pool Side', capacity:200,type:'Outdoor',color:C.teal, bg:'#D4F0F0'},
 {id:'v9',name:'Amphitheatre', capacity:350,type:'Outdoor',color:C.purple, bg:C.purpleBg},
];

// ── SOURCES ───────────────────────────────────────────────────────────────────
const SOURCES = [
 {id:'instagram', name:'Instagram', color:'#E91E63',bg:'#FCE4EC',count:28,today:4},
 {id:'facebook', name:'Facebook', color:'#2563A8',bg:'#DDEEFF',count:18,today:2},
 {id:'whatsapp', name:'WhatsApp', color:'#25D366',bg:'#E8FBF0',count:42,today:8},
 {id:'google', name:'Google Ads', color:'#D4840F',bg:'#FEF6E7',count:15,today:3},
 {id:'website', name:'Website', color:'#6B48A8',bg:'#F0EBFB',count:22,today:5},
 {id:'wedmegood', name:'WedMeGood', color:'#E05A00',bg:'#FEF0E6',count:12,today:1},
 {id:'shaadi', name:'ShaadiSaga', color:'#C83333',bg:'#FDEAEA',count:8, today:1},
 {id:'ota', name:'OTA', color:'#1A7A7A',bg:'#E7F5F5',count:19,today:2},
 {id:'referral', name:'Referral', color:'#3AAF58',bg:'#EAF7EE',count:31,today:3},
 {id:'walkin', name:'Walk-in', color:'#7A9A80',bg:'#0A1628',count:24,today:6},
];
const SRC = SOURCES.reduce((a,s)=>({...a,[s.id]:s}),{});

const LEADS = [
 {id:1,name:'Kapoor Family Wedding',contact:'Rahul Kapoor',phone:'+91 98100 11111',email:'rahul@kapoor.com',source:'wedmegood',type:'Wedding',pax:350,eventDate:'2026-08-15',budget:2200000,status:'Reserved',assignedTo:'Pooja Rawat',followUp:today,notes:'Venue shortlisted. Advance pending.',createdAt:'2026-07-01',venues:['v4','v7'],advancePaid:0,foodItems:[]},
 {id:2,name:'TechCorp Annual Outing',contact:'Sunita Mehta',phone:'+91 98100 22222',email:'hr@techcorp.com',source:'google',type:'Corporate',pax:280,eventDate:'2026-07-20',budget:650000,status:'Hot',assignedTo:'Pooja Rawat',followUp:today,notes:'Needs adventure package. Proposal sent.',createdAt:'2026-07-02',venues:['v5','v6'],advancePaid:0,foodItems:[]},
 {id:3,name:'GreenVille School Picnic',contact:'Mrs. Sharma',phone:'+91 98100 33333',email:'principal@greenville.edu',source:'referral',type:'School Picnic',pax:200,eventDate:'2026-07-18',budget:220000,status:'Confirmed',assignedTo:'Pooja Rawat',followUp:'2026-07-10',notes:'Advance received. Confirmed.',createdAt:'2026-07-02',venues:['v1','v5'],advancePaid:50000,foodItems:['Dal Makhani','Paneer Butter Masala','Roti','Rice','Samosa']},
 {id:4,name:'ABC Pharma MICE',contact:'Rajesh Gupta',phone:'+91 98100 55555',email:'rajesh@abcpharma.com',source:'google',type:'MICE',pax:120,eventDate:'2026-08-05',budget:980000,status:'Hot',assignedTo:'Pooja Rawat',followUp:today,notes:'Full day conference + team building.',createdAt:'2026-07-01',venues:['v3','v6'],advancePaid:0,foodItems:[]},
 {id:5,name:'DPS School Annual Trip',contact:'Mr. Verma',phone:'+91 98100 77777',email:'verma@dps.edu',source:'referral',type:'School Picnic',pax:320,eventDate:'2026-07-22',budget:380000,status:'Warm',assignedTo:'Pooja Rawat',followUp:'2026-07-05',notes:'Needs activity package.',createdAt:'2026-07-02',venues:[],advancePaid:0,foodItems:[]},
 {id:6,name:'Nair Wedding Kerala',contact:'Deepa Nair',phone:'+91 98100 88888',email:'deepa@gmail.com',source:'shaadi',type:'Wedding',pax:250,eventDate:'2026-09-12',budget:1800000,status:'Warm',assignedTo:'Pooja Rawat',followUp:'2026-07-07',notes:'Kerala theme. Catering is key.',createdAt:'2026-07-03',venues:[],advancePaid:0,foodItems:[]},
 {id:7,name:'Sharma Family Reunion',contact:'Vikram Sharma',phone:'+91 98100 66666',email:'vikram@gmail.com',source:'whatsapp',type:'Social Event',pax:60,eventDate:'2026-07-28',budget:120000,status:'Cold',assignedTo:'Pooja Rawat',followUp:'2026-07-06',notes:'WhatsApp enquiry. Brochure sent.',createdAt:'2026-07-03',venues:[],advancePaid:0,foodItems:[]},
 {id:8,name:'Priya Events Birthday',contact:'Priya Singh',phone:'+91 98100 44444',email:'priya@events.com',source:'instagram',type:'Social Event',pax:80,eventDate:'2026-07-25',budget:180000,status:'Lost',assignedTo:'Pooja Rawat',followUp:'2026-07-08',notes:'Budget too tight. Lost.',createdAt:'2026-07-03',venues:[],advancePaid:0,foodItems:[]},
];

const SC = {
 Hot: {color:C.red, bg:C.redBg, border:C.redBorder, grad:`linear-gradient(135deg,#E05050,${C.red})`},
 Warm: {color:C.amber, bg:C.amberBg, border:C.amberBorder, grad:`linear-gradient(135deg,#F0A030,${C.amber})`},
 Cold: {color:C.blue, bg:C.blueBg, border:'#B8D0F0', grad:`linear-gradient(135deg,#3070D0,${C.blue})`},
 Reserved: {color:C.purple, bg:C.purpleBg, border:'#C4B0E8', grad:`linear-gradient(135deg,#8060C0,${C.purple})`},
 Confirmed:{color:C.accent, bg:C.accentLight,border:'#A8D8B8', grad:`linear-gradient(135deg,${C.accent},${C.accentDark})`},
 Lost: {color:C.text3, bg:'#F0F0F0', border:C.border2, grad:`linear-gradient(135deg,#909090,#707070)`},
 Won: {color:C.accentDark,bg:'#D4EDD9',border:'#A8D8B8', grad:`linear-gradient(135deg,${C.accentDark},#1A5A28)`},
};

// FOOD MENU DATA
const FOOD_MENU = {
 'Breakfast':['Poha','Upma','Idli Sambhar','Masala Dosa','Aloo Paratha','Tea','Coffee','Fresh Juice'],
 'Lunch — Veg':['Dal Makhani','Paneer Butter Masala','Shahi Paneer','Kadai Paneer','Mix Veg','Rajma','Tandoori Roti','Butter Naan','Garlic Naan','Steamed Rice','Jeera Rice','Veg Biryani','Raita','Green Salad','Gulab Jamun','Kheer'],
 'Lunch — Non Veg':['Butter Chicken','Chicken Curry','Mutton Rogan Josh','Fish Curry','Chicken Biryani','Mutton Biryani'],
 'Chinese':['Veg Fried Rice','Chicken Fried Rice','Veg Noodles','Chicken Noodles','Veg Manchurian','Chilli Chicken','Chilli Paneer','Spring Rolls'],
 'Hi-Tea — Veg':['Samosa','Veg Pakora','Paneer Tikka','Hara Bhara Kebab','Aloo Tikki','Pav Bhaji','Tea','Coffee','Cold Coffee','Lassi','Lemonade'],
 'Hi-Tea — Non Veg':['Chicken Tikka','Seekh Kebab','Fish Tikka','Tandoori Chicken'],
 'Dinner':['Dal Makhani','Paneer Butter Masala','Butter Chicken','Mutton Curry','Tandoori Roti','Garlic Naan','Veg Biryani','Chicken Biryani','Gulab Jamun','Ice Cream'],
};


// ── ATOMS ─────────────────────────────────────────────────────────────────────
const Btn = ({children,onClick,v='primary',style={},disabled}) => {
 const vs={
 primary:{background:`linear-gradient(135deg,${C.accent},${C.accentDark})`,color:'#fff',border:'none',boxShadow:'0 3px 10px rgba(58,175,88,.25)'},
 ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`,boxShadow:'none'},
 red:{background:`linear-gradient(135deg,#E05050,${C.red})`,color:'#fff',border:'none',boxShadow:'0 3px 8px rgba(200,51,51,.2)'},
 amber:{background:`linear-gradient(135deg,#F0A030,${C.amber})`,color:'#fff',border:'none',boxShadow:'0 3px 8px rgba(212,132,15,.2)'},
 purple:{background:`linear-gradient(135deg,#8060C0,${C.purple})`,color:'#fff',border:'none',boxShadow:'0 3px 8px rgba(107,72,168,.2)'},
 blue:{background:`linear-gradient(135deg,#3070D0,${C.blue})`,color:'#fff',border:'none',boxShadow:'0 3px 8px rgba(37,99,168,.2)'},
 dark:{background:`linear-gradient(135deg,${C.dark2},${C.dark})`,color:'#fff',border:'none',boxShadow:'0 3px 8px rgba(0,0,0,.2)'},
 outline:{background:'transparent',color:C.accent,border:`1.5px solid ${C.accent}`,boxShadow:'none'},
 };
 return <button onClick={onClick} disabled={disabled} style={{...vs[v]||vs.primary,padding:'9px 18px',borderRadius:10,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.5:1,display:'inline-flex',alignItems:'center',gap:6,whiteSpace:'nowrap',transition:'all .15s',...style}}>{children}</button>;
};

// ── MINI SPARKLINE ────────────────────────────────────────────────────────────
const Spark = ({data,color}) => {
 const max=Math.max(...data),min=Math.min(...data);
 const pts=data.map((v,i)=>`${i*(60/(data.length-1))},${20-((v-min)/(max-min||1))*18}`).join(' ');
 return <svg width={60} height={20} style={{display:'block'}}><polyline points={pts} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/></svg>;
};

// ── KPI CARD ─────────────────────────────────────────────────────────────────
const KpiCard = ({label,value,sub,icon,color,bg,spark,trend,onClick}) => (
 <div onClick={onClick} style={{background:C.surface,borderRadius:16,padding:'18px 20px',border:`1px solid ${C.border}`,boxShadow:'0 2px 12px rgba(0,0,0,.06)',cursor:onClick?'pointer':'default',transition:'all .15s',position:'relative',overflow:'hidden'}}>
 <div style={{position:'absolute',top:-20,right:-20,width:80,height:80,borderRadius:'50%',background:bg||C.accentLight,opacity:.5}}/>
 <div style={{position:'relative'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
 <div style={{width:40,height:40,borderRadius:12,background:bg||C.accentLight,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>{icon}</div>
 {spark&&<Spark data={spark} color={color||C.accent}/>}
 </div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:28,fontWeight:800,color:color||C.text,letterSpacing:'-.03em',marginBottom:4}}>{value}</div>
 <div style={{fontSize:12,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em'}}>{label}</div>
 {sub&&<div style={{fontSize:11,color:trend>0?C.accent:trend<0?C.red:C.text3,marginTop:4,fontWeight:600}}>{trend>0?'↑':trend<0?'↓':''} {sub}</div>}
 </div>
 </div>
);

// ── LEAD CARD ─────────────────────────────────────────────────────────────────
const LeadCard = ({lead,onClick,compact}) => {
 const sc=SC[lead.status]||SC.Cold;
 const src=SRC[lead.source]||{color:C.text3,bg:C.bg,name:lead.source};
 const pctPaid = lead.budget>0?Math.min(100,Math.round((lead.advancePaid/lead.budget)*100)):0;
 return (
 <div onClick={onClick} style={{background:C.surface,borderRadius:14,border:`1.5px solid ${sc.border}`,padding:compact?'12px 14px':'16px 18px',cursor:'pointer',boxShadow:'0 2px 8px rgba(0,0,0,.05)',transition:'all .15s',position:'relative',overflow:'hidden'}}>
 {/* Color band on left */}
 <div style={{position:'absolute',left:0,top:0,bottom:0,width:4,background:sc.grad,borderRadius:'14px 0 0 14px'}}/>
 <div style={{marginLeft:8}}>
 <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,marginBottom:6}}>
 <div style={{flex:1}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:compact?13:15,fontWeight:800,color:C.text,marginBottom:3}}>{lead.name}</div>
 <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
 <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:700,color:sc.color,background:sc.bg,border:`1px solid ${sc.border}`}}>{sc.icon} {lead.status}</span>
 <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:src.color,background:src.bg}}>{src.icon} {src.name}</span>
 <span style={{padding:'2px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:C.blue,background:C.blueBg}}>{lead.type}</span>
 </div>
 </div>
 <div style={{textAlign:'right',flexShrink:0}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:compact?16:20,fontWeight:800,color:C.accent}}>{inr(lead.budget/100000)}L</div>
 <div style={{fontSize:10,color:C.text3}}>{lead.pax} pax</div>
 </div>
 </div>
 {!compact&&<>
 <div style={{fontSize:11,color:C.text3,marginBottom:6}}>{lead.contact} · {lead.phone} · {fmtDate(lead.eventDate)}</div>
 {/* Progress bar for advance */}
 {lead.budget>0&&<div style={{marginBottom:6}}>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:C.text3,marginBottom:3}}>
 <span>Advance: {inr(lead.advancePaid)}</span>
 <span style={{color:pctPaid>0?C.accent:C.text3,fontWeight:600}}>{pctPaid}% paid</span>
 </div>
 <div style={{height:4,background:C.border,borderRadius:99}}>
 <div style={{height:4,width:`${pctPaid}%`,background:`linear-gradient(90deg,${C.accent},${C.accentDark})`,borderRadius:99,transition:'width .3s'}}/>
 </div>
 </div>}
 <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
 {lead.venues?.length>0&&<span style={{fontSize:10,color:C.purple,fontWeight:600}}> {lead.venues.length} venue{lead.venues.length>1?'s':''}</span>}
 {lead.foodItems?.length>0&&<span style={{fontSize:10,color:C.accent,fontWeight:600}}> {lead.foodItems.length} food items</span>}
 {lead.followUp===today&&<span style={{fontSize:10,color:C.red,fontWeight:700}}> Follow-up TODAY</span>}
 </div>
 </>}
 </div>
 </div>
 );
};


// ── DASHBOARD ─────────────────────────────────────────────────────────────────
function Dashboard({leads,venues,onOpen}) {
 const hot=leads.filter(l=>l.status==='Hot');
 const warm=leads.filter(l=>l.status==='Warm');
 const reserved=leads.filter(l=>l.status==='Reserved');
 const confirmed=leads.filter(l=>l.status==='Confirmed');
 const followToday=leads.filter(l=>l.followUp===today&&!['Lost','Won'].includes(l.status));
 const pipeline=leads.filter(l=>!['Lost','Won'].includes(l.status)).reduce((s,l)=>s+l.budget,0);
 const totalSrc=SOURCES.reduce((s,l)=>s+l.count,0);

 return (
 <div>
 {/* ── HERO BANNER ── */}
 <div style={{borderRadius:20,overflow:'hidden',marginBottom:24,boxShadow:'0 8px 32px rgba(0,0,0,.15)'}}>
 {/* Top band — dark green gradient */}
 <div style={{background:`linear-gradient(135deg,${C.dark} 0%,${C.dark2} 60%,#0A2010 100%)`,padding:'28px 32px',position:'relative',overflow:'hidden'}}>
 <div style={{position:'absolute',top:-60,right:-40,width:280,height:280,borderRadius:'50%',background:'rgba(58,175,88,.06)'}}/>
 <div style={{position:'absolute',bottom:-80,left:200,width:200,height:200,borderRadius:'50%',background:'rgba(58,175,88,.04)'}}/>
 <div style={{position:'relative',display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
 <div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.16em',marginBottom:6}}> Botanix Nature Resort · Sales Command Centre</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:32,fontWeight:800,color:'#fff',letterSpacing:'-.03em'}}>Sales CRM Dashboard</div>
 <div style={{fontSize:13,color:'rgba(255,255,255,.4)',marginTop:4}}>{new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontSize:11,color:'rgba(255,255,255,.3)',marginBottom:4}}>Total Pipeline Value</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:36,fontWeight:800,color:C.accent,letterSpacing:'-.03em'}}>{inr(pipeline)}</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.3)',marginTop:2}}>{leads.filter(l=>!['Lost','Won'].includes(l.status)).length} active leads</div>
 </div>
 </div>
 {/* KPI row */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:10}}>
 {[
 {l:'Total Leads',v:leads.length,ic:'',c:'rgba(255,255,255,.9)',bg:'rgba(255,255,255,.07)'},
 {l:'Hot Leads',v:hot.length,ic:'',c:'#FF6B6B',bg:'rgba(200,51,51,.15)'},
 {l:'Warm Leads',v:warm.length,ic:'',c:'#FFB347',bg:'rgba(212,132,15,.15)'},
 {l:'Reserved',v:reserved.length,ic:'',c:'#CE93D8',bg:'rgba(107,72,168,.15)'},
 {l:'Confirmed',v:confirmed.length,ic:'',c:'#81C784',bg:'rgba(58,175,88,.15)'},
 {l:'Follow Today',v:followToday.length,ic:'',c:followToday.length>0?'#FF6B6B':'rgba(255,255,255,.7)',bg:followToday.length>0?'rgba(200,51,51,.15)':'rgba(255,255,255,.06)'},
 {l:'Sources',v:totalSrc,ic:'',c:'rgba(255,255,255,.8)',bg:'rgba(255,255,255,.06)'},
 ].map(k=>(
 <div key={k.l} style={{padding:'14px 12px',background:k.bg,borderRadius:14,border:'1px solid rgba(255,255,255,.06)',textAlign:'center'}}>
 <div style={{fontSize:22,marginBottom:6}}>{k.ic}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:28,fontWeight:800,color:k.c,letterSpacing:'-.02em'}}>{k.v}</div>
 <div style={{fontSize:9,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.06em',marginTop:4,lineHeight:1.3}}>{k.l}</div>
 </div>
 ))}
 </div>
 </div>
 {/* Bottom band — lighter green */}
 <div style={{background:`linear-gradient(135deg,#1A4A20,#243828)`,padding:'14px 32px',display:'flex',alignItems:'center',gap:20,overflowX:'auto'}}>
 <span style={{fontSize:11,color:'rgba(255,255,255,.3)',whiteSpace:'nowrap'}}>Today's leads by source:</span>
 {SOURCES.filter(s=>s.today>0).map(s=>(
 <div key={s.id} style={{display:'flex',alignItems:'center',gap:6,background:'rgba(255,255,255,.06)',padding:'5px 12px',borderRadius:99,flexShrink:0}}>
 <span style={{fontSize:14}}>{s.icon}</span>
 <span style={{fontSize:12,fontWeight:600,color:'rgba(255,255,255,.7)'}}>{s.name}</span>
 <span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:s.color}}>+{s.today}</span>
 </div>
 ))}
 </div>
 </div>

 {/* ── 3-COLUMN SECTION ── */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16,marginBottom:16}}>

 {/* Follow-ups Today */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(212,132,15,.12)'}}>
 <div style={{background:`linear-gradient(135deg,#F0A030,${C.amber})`,padding:'16px 18px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:'#fff'}}> Follow-ups Today</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.6)',marginTop:2}}>Must contact today</div>
 </div>
 <div style={{width:42,height:42,borderRadius:12,background:'rgba(255,255,255,.2)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:'#fff'}}>{followToday.length}</div>
 </div>
 <div style={{background:'#FFFBF5',border:`1px solid ${C.amberBorder}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'12px',maxHeight:300,overflowY:'auto',display:'flex',flexDirection:'column',gap:8}}>
 {followToday.length===0
 ? <div style={{textAlign:'center',padding:'24px',color:C.text3}}> All caught up!</div>
 : followToday.map(l=><LeadCard key={l.id} lead={l} onClick={()=>onOpen(l)} compact/>)
 }
 </div>
 </div>

 {/* Hot Leads */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(200,51,51,.12)'}}>
 <div style={{background:`linear-gradient(135deg,#E05050,${C.red})`,padding:'16px 18px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:'#fff'}}> Hot Leads</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.6)',marginTop:2}}>Close these first!</div>
 </div>
 <div style={{width:42,height:42,borderRadius:12,background:'rgba(255,255,255,.2)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:'#fff'}}>{hot.length}</div>
 </div>
 <div style={{background:'#FFF8F8',border:`1px solid ${C.redBorder}`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'12px',maxHeight:300,overflowY:'auto',display:'flex',flexDirection:'column',gap:8}}>
 {hot.map(l=><LeadCard key={l.id} lead={l} onClick={()=>onOpen(l)} compact/>)}
 </div>
 </div>

 {/* Reserved & Confirmed */}
 <div style={{borderRadius:16,overflow:'hidden',boxShadow:'0 4px 16px rgba(58,175,88,.12)'}}>
 <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentDark})`,padding:'16px 18px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:'#fff'}}> Reserved & Confirmed</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.6)',marginTop:2}}>Pending advance payment</div>
 </div>
 <div style={{width:42,height:42,borderRadius:12,background:'rgba(255,255,255,.2)',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:'#fff'}}>{reserved.length+confirmed.length}</div>
 </div>
 <div style={{background:C.accentLight,border:`1px solid #A8D8B8`,borderTop:'none',borderRadius:'0 0 16px 16px',padding:'12px',maxHeight:300,overflowY:'auto',display:'flex',flexDirection:'column',gap:8}}>
 {[...reserved,...confirmed].map(l=><LeadCard key={l.id} lead={l} onClick={()=>onOpen(l)} compact/>)}
 </div>
 </div>
 </div>

 {/* ── LEAD SOURCES VISUAL ── */}
 <div style={{background:C.surface,borderRadius:16,overflow:'hidden',marginBottom:16,boxShadow:'0 2px 12px rgba(0,0,0,.06)'}}>
 <div style={{background:`linear-gradient(135deg,${C.dark2},#243828)`,padding:'14px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:'#fff'}}> Lead Sources — This Month</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.3)'}}>Total {totalSrc} leads · +{SOURCES.reduce((s,l)=>s+l.today,0)} today</div>
 </div>
 <div style={{padding:'16px 20px',display:'grid',gridTemplateColumns:'repeat(10,1fr)',gap:10}}>
 {SOURCES.map(s=>{
 const pct=Math.round(s.count/totalSrc*100);
 return (
 <div key={s.id} style={{textAlign:'center',padding:'12px 6px',background:s.bg,borderRadius:14,border:`1px solid ${s.color}22`,position:'relative'}}>
 <div style={{fontSize:22,marginBottom:5}}>{s.icon}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:s.color,letterSpacing:'-.02em'}}>{s.count}</div>
 <div style={{fontSize:9,fontWeight:700,color:C.text,marginTop:2,lineHeight:1.2}}>{s.name}</div>
 <div style={{fontSize:9,color:s.color,fontWeight:700,marginTop:2}}>+{s.today} today</div>
 <div style={{marginTop:6,height:3,background:`${s.color}22`,borderRadius:99}}>
 <div style={{height:3,width:`${pct}%`,background:s.color,borderRadius:99}}/>
 </div>
 </div>
 );
 })}
 </div>
 </div>

 {/* ── VENUE AVAILABILITY ── */}
 <div style={{background:C.surface,borderRadius:16,overflow:'hidden',boxShadow:'0 2px 12px rgba(0,0,0,.06)'}}>
 <div style={{background:`linear-gradient(135deg,${C.purple},#4A2880)`,padding:'14px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:'#fff'}}> Venue Availability — Live</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.3)'}}>Green = Available · Coloured = Booked</div>
 </div>
 <div style={{padding:'16px 20px',display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
 {venues.map(v=>{
 const booked=leads.filter(l=>l.venues?.includes(v.id)&&!['Lost'].includes(l.status));
 return (
 <div key={v.id} style={{padding:'14px 16px',background:booked.length>0?v.bg:C.bg,borderRadius:12,border:`1.5px solid ${booked.length>0?v.color:C.border}`,transition:'all .2s'}}>
 <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:booked.length>0?8:0}}>
 <div style={{width:40,height:40,borderRadius:11,background:booked.length>0?v.color+'22':C.border,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>{v.icon}</div>
 <div style={{flex:1}}>
 <div style={{fontWeight:700,fontSize:13,color:C.text}}>{v.name}</div>
 <div style={{fontSize:10,color:C.text3}}>{v.type} · {v.capacity} cap</div>
 </div>
 <div style={{width:10,height:10,borderRadius:'50%',background:booked.length>0?v.color:C.accent,boxShadow:`0 0 6px ${booked.length>0?v.color:C.accent}`}}/>
 </div>
 {booked.length>0
 ? booked.map(l=><div key={l.id} style={{fontSize:11,color:v.color,fontWeight:600,padding:'4px 8px',background:v.color+'15',borderRadius:7,marginTop:4}}> {l.name} · {fmtDate(l.eventDate)}</div>)
 : null
 }
 {booked.length===0&&<div style={{fontSize:11,color:C.accent,fontWeight:600,marginTop:4}}> Available to book</div>}
 </div>
 );
 })}
 </div>
 </div>
 </div>
 );
}


// ── LEAD PANEL (SLIDE-IN) ─────────────────────────────────────────────────────
function LeadPanel({lead,onClose,onUpdate,venues,allLeads}) {
 const [note,setNote]=useState('');
 const [advance,setAdvance]=useState('');
 const [showFood,setShowFood]=useState(false);
 const [foodCat,setFoodCat]=useState('Lunch — Veg');
 const [selFood,setSelFood]=useState(lead.foodItems||[]);
 const sc=SC[lead.status]||SC.Cold;
 const src=SRC[lead.source]||{name:lead.source};
 const pctPaid=lead.budget>0?Math.min(100,Math.round((lead.advancePaid/lead.budget)*100)):0;

 const recordAdvance=()=>{
 const amt=parseFloat(advance)||0;
 if(amt<=0)return alert('Enter valid amount');
 onUpdate(lead.id,'advancePaid',(lead.advancePaid||0)+amt);
 onUpdate(lead.id,'status','Confirmed');
 setAdvance('');
 };

 const toggleVenue=(vid)=>{
 const cur=lead.venues||[];
 onUpdate(lead.id,'venues',cur.includes(vid)?cur.filter(v=>v!==vid):[...cur,vid]);
 };

 const saveFood=()=>{
 onUpdate(lead.id,'foodItems',selFood);
 setShowFood(false);
 };

 return (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.55)',zIndex:300,display:'flex',justifyContent:'flex-end'}}>
 <div style={{width:560,background:C.surface,height:'100%',overflowY:'auto',boxShadow:'-8px 0 40px rgba(0,0,0,.2)',display:'flex',flexDirection:'column'}}>

 {/* Header */}
 <div style={{background:`linear-gradient(135deg,${C.dark} 0%,${C.dark2} 100%)`,padding:'24px',flexShrink:0}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14}}>
 <div style={{flex:1,marginRight:12}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:'#fff',marginBottom:5,lineHeight:1.2}}>{lead.name}</div>
 <div style={{fontSize:12,color:'rgba(255,255,255,.4)',marginBottom:10}}> {lead.phone} &nbsp;·&nbsp; {lead.email}</div>
 <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
 <span style={{padding:'4px 12px',borderRadius:99,fontSize:12,fontWeight:700,color:sc.color,background:sc.bg,border:`1px solid ${sc.border}`}}>{sc.icon} {lead.status}</span>
 <span style={{padding:'4px 12px',borderRadius:99,fontSize:11,color:'rgba(255,255,255,.6)',background:'rgba(255,255,255,.08)'}}>{src.icon} {src.name}</span>
 <span style={{padding:'4px 12px',borderRadius:99,fontSize:11,color:'rgba(255,255,255,.6)',background:'rgba(255,255,255,.08)'}}>{lead.type} · {lead.pax} pax</span>
 </div>
 </div>
 <button onClick={onClose} style={{width:34,height:34,borderRadius:10,border:'1px solid rgba(255,255,255,.15)',background:'rgba(255,255,255,.08)',color:'#fff',cursor:'pointer',fontSize:16,flexShrink:0}}></button>
 </div>
 {/* 3 metrics */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
 {[['Deal Value',inr(lead.budget),C.accent],['Event Date',fmtDate(lead.eventDate),'rgba(255,255,255,.8)'],['Advance',inr(lead.advancePaid||0),lead.advancePaid>0?'#81C784':'rgba(255,255,255,.4)']].map(([k,v,c])=>(
 <div key={k} style={{padding:'10px 12px',background:'rgba(255,255,255,.07)',borderRadius:11}}>
 <div style={{fontSize:9,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.07em',marginBottom:4}}>{k}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:c}}>{v}</div>
 </div>
 ))}
 </div>
 {/* Advance progress bar */}
 {lead.budget>0&&<div style={{marginTop:12}}>
 <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:'rgba(255,255,255,.3)',marginBottom:5}}>
 <span>Advance progress</span><span style={{color:C.accent,fontWeight:700}}>{pctPaid}% paid</span>
 </div>
 <div style={{height:6,background:'rgba(255,255,255,.1)',borderRadius:99}}>
 <div style={{height:6,width:`${pctPaid}%`,background:`linear-gradient(90deg,${C.accent},${C.accentDark})`,borderRadius:99,transition:'width .4s',boxShadow:`0 0 8px ${C.accent}`}}/>
 </div>
 </div>}
 </div>

 {/* Body */}
 <div style={{flex:1,padding:20,display:'flex',flexDirection:'column',gap:14}}>

 {/* ── QUICK STATUS ACTIONS ── */}
 <div style={{background:C.bg,borderRadius:14,padding:'14px 16px',border:`1px solid ${C.border}`}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:10}}> Quick Actions — One Click</div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
 {[
 {l:' Mark Hot', v:'red', s:'Hot', hide:lead.status==='Hot'},
 {l:' Warm', v:'amber', s:'Warm', hide:lead.status==='Warm'},
 {l:' Cold', v:'blue', s:'Cold', hide:lead.status==='Cold'},
 {l:' Reserve', v:'purple', s:'Reserved', hide:lead.status==='Reserved'},
 {l:' Deal Won', v:'dark', s:'Won', hide:lead.status==='Won'},
 {l:' Mark Lost', v:'ghost', s:'Lost', hide:lead.status==='Lost'},
 ].filter(a=>!a.hide).slice(0,6).map(a=>(
 <Btn key={a.l} v={a.v} onClick={()=>onUpdate(lead.id,'status',a.s)} style={{fontSize:11,padding:'8px',justifyContent:'center'}}>{a.l}</Btn>
 ))}
 </div>
 </div>

 {/* ── ADVANCE PAYMENT ── */}
 <div style={{borderRadius:14,overflow:'hidden',border:`1.5px solid ${lead.advancePaid>0?C.accent:C.amberBorder}`}}>
 <div style={{background:lead.advancePaid>0?`linear-gradient(135deg,${C.accent},${C.accentDark})`:`linear-gradient(135deg,#F0A030,${C.amber})`,padding:'12px 16px'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:'#fff'}}>
 {lead.advancePaid>0?`Advance Received: ${inr(lead.advancePaid)}`:'Record Advance → Auto-Confirm Booking'}
 </div>
 </div>
 <div style={{padding:'12px 16px',background:lead.advancePaid>0?C.accentLight:C.amberBg}}>
 {lead.status!=='Confirmed'
 ? <div style={{display:'flex',gap:8}}>
 <input type="number" value={advance} onChange={e=>setAdvance(e.target.value)} placeholder="Enter advance amount (₹)"
 style={{flex:1,padding:'9px 12px',background:'#006b3c',border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}/>
 <Btn onClick={recordAdvance} style={{fontSize:12,padding:'9px 16px'}}> Record & Confirm</Btn>
 </div>
 : <div style={{fontSize:13,color:C.accent,fontWeight:700}}> Booking CONFIRMED! Advance of {inr(lead.advancePaid)} received.</div>
 }
 </div>
 </div>

 {/* ── VENUE RESERVATION ── */}
 <div style={{background:C.bg,borderRadius:14,padding:'14px 16px',border:`1px solid ${C.border}`}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:10}}>
 Venue Reservation for {fmtDate(lead.eventDate)}
 </div>
 {(lead.venues||[]).length>0&&(
 <div style={{marginBottom:10}}>
 <div style={{fontSize:11,color:C.purple,fontWeight:600,marginBottom:6}}>Currently Reserved:</div>
 <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
 {venues.filter(v=>(lead.venues||[]).includes(v.id)).map(v=>(
 <button key={v.id} onClick={()=>toggleVenue(v.id)} style={{padding:'6px 12px',borderRadius:99,background:v.bg,border:`1.5px solid ${v.color}`,color:v.color,fontSize:12,fontWeight:600,cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
 {v.icon} {v.name} <span style={{opacity:.6}}></span>
 </button>
 ))}
 </div>
 </div>
 )}
 <div style={{fontSize:11,color:C.accent,fontWeight:600,marginBottom:6}}> Add Venue:</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
 {venues.filter(v=>!(lead.venues||[]).includes(v.id)).map(v=>{
 const conflict=allLeads.filter(l=>l.id!==lead.id&&(l.venues||[]).includes(v.id)&&!['Lost'].includes(l.status)&&l.eventDate===lead.eventDate);
 return (
 <button key={v.id} onClick={()=>conflict.length===0&&toggleVenue(v.id)}
 style={{padding:'8px 10px',borderRadius:10,background:conflict.length>0?C.redBg:C.surface,border:`1.5px solid ${conflict.length>0?C.redBorder:C.border2}`,color:conflict.length>0?C.red:C.text2,fontSize:11,fontWeight:500,cursor:conflict.length>0?'not-allowed':'pointer',textAlign:'left',opacity:conflict.length>0?.7:1}}>
 {v.icon} {v.name}
 {conflict.length>0&&<div style={{fontSize:9,color:C.red,marginTop:2}}>Booked</div>}
 </button>
 );
 })}
 </div>
 </div>

 {/* ── FOOD MENU ── */}
 <div style={{borderRadius:14,overflow:'hidden',border:`1.5px solid ${selFood.length>0?C.accent:C.border}`}}>
 <div style={{background:selFood.length>0?`linear-gradient(135deg,${C.accent},${C.accentDark})`:`linear-gradient(135deg,#607060,#405040)`,padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:'#fff'}}>
 Food Menu {selFood.length>0?`— ${selFood.length} items selected`:'— Not selected yet'}
 </div>
 <button onClick={()=>setShowFood(!showFood)} style={{padding:'5px 12px',borderRadius:8,background:'rgba(255,255,255,.2)',border:'none',color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer'}}>
 {showFood?'Hide':'Select Menu'}
 </button>
 </div>
 {showFood&&(
 <div style={{padding:'14px 16px',background:C.accentLight}}>
 <div style={{display:'flex',gap:6,marginBottom:12,flexWrap:'wrap'}}>
 {Object.keys(FOOD_MENU).map(cat=>(
 <button key={cat} onClick={()=>setFoodCat(cat)}
 style={{padding:'5px 12px',borderRadius:99,fontSize:11,fontWeight:600,border:`1px solid ${foodCat===cat?C.accent:C.border2}`,background:foodCat===cat?C.accent:'transparent',color:foodCat===cat?'#fff':C.text2,cursor:'pointer'}}>
 {cat}
 </button>
 ))}
 </div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6,marginBottom:12,maxHeight:200,overflowY:'auto'}}>
 {(FOOD_MENU[foodCat]||[]).map(item=>{
 const isSel=selFood.includes(item);
 return (
 <button key={item} onClick={()=>setSelFood(p=>isSel?p.filter(x=>x!==item):[...p,item])}
 style={{padding:'8px 12px',borderRadius:9,background:isSel?C.accentLight:C.surface,border:`1.5px solid ${isSel?C.accent:C.border}`,color:isSel?C.accent:C.text,fontSize:12,fontWeight:isSel?700:400,cursor:'pointer',textAlign:'left'}}>
 {isSel?' ':''}{item}
 </button>
 );
 })}
 </div>
 {selFood.length>0&&(
 <div style={{padding:'8px 12px',background:C.surface,borderRadius:9,border:`1px solid ${C.border}`,marginBottom:10,fontSize:12,color:C.text2}}>
 <strong style={{color:C.accent}}>Selected:</strong> {selFood.join(', ')}
 </div>
 )}
 <Btn onClick={saveFood} style={{fontSize:12,width:'100%',justifyContent:'center'}}> Save Food Selection</Btn>
 </div>
 )}
 {!showFood&&selFood.length>0&&(
 <div style={{padding:'10px 16px',background:C.accentLight,fontSize:12,color:C.text2}}>
 {selFood.slice(0,5).join(', ')}{selFood.length>5?` +${selFood.length-5} more`:''}
 </div>
 )}
 </div>

 {/* ── NOTES ── */}
 <div style={{background:C.bg,borderRadius:14,padding:'14px 16px',border:`1px solid ${C.border}`}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}> Notes & Follow-up</div>
 <div style={{fontSize:13,color:C.text2,fontStyle:'italic',padding:'8px 12px',background:C.surface,borderRadius:9,marginBottom:10,border:`1px solid ${C.border}`}}>{lead.notes||'No notes yet'}</div>
 <textarea value={note} onChange={e=>setNote(e.target.value)} rows={2} placeholder="Add follow-up note, client response, next step..."
 style={{width:'100%',padding:'9px 12px',background:'#006b3c',border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',resize:'none',boxSizing:'border-box',marginBottom:8}}/>
 <Btn onClick={()=>{if(note){onUpdate(lead.id,'notes',note);setNote('');}}} style={{fontSize:12,padding:'7px 16px'}}> Save Note</Btn>
 </div>
 </div>
 </div>
 </div>
 );
}

// ── PIPELINE ──────────────────────────────────────────────────────────────────
function Pipeline({leads,onOpen}) {
 const cols=['Hot','Warm','Cold','Reserved','Confirmed','Lost'];
 return (
 <div>
 <div style={{fontSize:14,fontWeight:600,color:C.text3,marginBottom:16}}>Drag-and-drop pipeline view — click any card to open</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:12}}>
 {cols.map(col=>{
 const sc=SC[col]||SC.Cold;
 const colLeads=leads.filter(l=>l.status===col);
 const val=colLeads.reduce((s,l)=>s+l.budget,0);
 return (
 <div key={col}>
 <div style={{padding:'12px 14px',background:sc.grad,borderRadius:'14px 14px 0 0',marginBottom:0}}>
 <div style={{fontSize:20,marginBottom:4}}>{sc.icon}</div>
 <div style={{fontSize:14,fontWeight:800,color:'#fff'}}>{col}</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.6)',marginTop:2}}>{colLeads.length} leads · {inr(val/100000)}L</div>
 </div>
 <div style={{background:C.bg,border:`1px solid ${C.border}`,borderTop:'none',borderRadius:'0 0 14px 14px',padding:8,minHeight:200,display:'flex',flexDirection:'column',gap:6}}>
 {colLeads.map(l=>(
 <div key={l.id} onClick={()=>onOpen(l)} style={{background:C.surface,borderRadius:10,padding:'10px 12px',cursor:'pointer',border:`1px solid ${C.border}`,boxShadow:'0 1px 4px rgba(0,0,0,.04)',borderLeft:`3px solid ${sc.color}`}}>
 <div style={{fontWeight:700,fontSize:12,color:C.text,marginBottom:3,lineHeight:1.3}}>{l.name}</div>
 <div style={{fontSize:10,color:C.text3,marginBottom:4}}>{l.type} · {l.pax} pax · {fmtDate(l.eventDate)}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:sc.color}}>{inr(l.budget/100000)}L</div>
 {l.venues?.length>0&&<div style={{fontSize:9,color:C.purple,marginTop:3}}> {l.venues.length} venue{l.venues.length>1?'s':''}</div>}
 {l.foodItems?.length>0&&<div style={{fontSize:9,color:C.accent}}> {l.foodItems.length} food items</div>}
 </div>
 ))}
 </div>
 </div>
 );
 })}
 </div>
 </div>
 );
}

// ── VENUE MANAGER ─────────────────────────────────────────────────────────────
function VenueManager({venues,setVenues}) {
 const [form,setForm]=useState({name:'',capacity:100,type:'Outdoor'});
 const save=()=>{
 if(!form.name)return alert('Enter venue name');
 setVenues(p=>[...p,{...form,id:'v'+Date.now(),color:C.accent,bg:C.accentLight}]);
 setForm({name:'',capacity:100,type:'Outdoor'});
 };
 return (
 <div>
 <div style={{background:C.surface,borderRadius:16,padding:24,marginBottom:20,border:`1px solid ${C.border}`,boxShadow:'0 2px 12px rgba(0,0,0,.06)'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text,marginBottom:16}}> Add New Venue</div>
 <div style={{display:'grid',gridTemplateColumns:'2fr 80px 120px 140px 120px',gap:10,alignItems:'flex-end'}}>
 {[['Venue Name','name','Pilkhan Garden'],['Icon','icon',''],['Capacity','capacity','100']].map(([l,k,ph])=>(
 <div key={k}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{l}</div>
 <input value={form[k]} onChange={e=>setForm(p=>({...p,[k]:k==='capacity'?parseInt(e.target.value)||0:e.target.value}))} placeholder={ph}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 </div>
 ))}
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>Type</div>
 <select value={form.type} onChange={e=>setForm(p=>({...p,type:e.target.value}))}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}>
 {['Outdoor','Indoor','Both'].map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t}>{t}</option>)}
 </select>
 </div>
 <Btn onClick={save} style={{alignSelf:'flex-end'}}> Add</Btn>
 </div>
 </div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
 {venues.map(v=>(
 <div key={v.id} style={{background:C.surface,borderRadius:14,overflow:'hidden',border:`1px solid ${C.border}`,boxShadow:'0 2px 8px rgba(0,0,0,.05)'}}>
 <div style={{background:v.color,padding:'12px 16px',display:'flex',alignItems:'center',gap:10}}>
 <span style={{fontSize:24}}>{v.icon}</span>
 <div>
 <div style={{fontWeight:800,fontSize:14,color:'#fff'}}>{v.name}</div>
 <div style={{fontSize:11,color:'rgba(255,255,255,.6)'}}>{v.type} · Capacity: {v.capacity}</div>
 </div>
 </div>
 <div style={{padding:'12px 16px',display:'flex',gap:8}}>
 <button onClick={()=>setVenues(p=>p.filter(x=>x.id!==v.id))} style={{flex:1,padding:'7px',borderRadius:8,border:`1px solid ${C.redBorder}`,background:C.redBg,color:C.red,fontSize:12,fontWeight:600,cursor:'pointer'}}> Delete</button>
 </div>
 </div>
 ))}
 </div>
 </div>
 );
}

// ── NEW LEAD ──────────────────────────────────────────────────────────────────
function NewLead({onSave,onClose}) {
 const [f,setF]=useState({name:'',contact:'',phone:'',email:'',source:'whatsapp',type:'Corporate',pax:100,eventDate:'',budget:'',notes:'',assignedTo:'Pooja Rawat',followUp:today,status:'Warm'});
 const u=k=>v=>setF(p=>({...p,[k]:v}));
 const inp=(l,k,ph,t='text')=>(
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{l}</div>
 <input type={t} value={f[k]} onChange={e=>u(k)(e.target.value)} placeholder={ph} style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 </div>
 );
 const sel=(l,k,opts)=>(
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{l}</div>
 <select value={f[k]} onChange={e=>u(k)(e.target.value)} style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}>
 {opts.map(o=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={typeof o==='string'?o:o.v} value={typeof o==='string'?o:o.v}>{typeof o==='string'?o:o.l}</option>)}
 </select>
 </div>
 );
 return (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
 <div style={{background:C.surface,borderRadius:20,width:640,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 24px 64px rgba(0,0,0,.2)'}}>
 <div style={{background:`linear-gradient(135deg,${C.dark},${C.dark2})`,padding:'20px 24px',borderRadius:'20px 20px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:'#fff'}}> Add New Lead</div>
 <button onClick={onClose} style={{width:32,height:32,borderRadius:9,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.1)',color:'#fff',cursor:'pointer',fontSize:16}}></button>
 </div>
 <div style={{padding:24}}>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
 {inp('Group / Company Name','name','Kapoor Family Wedding')}
 {inp('Contact Person','contact','Rahul Kapoor')}
 {inp('Phone','phone','+91 98100 00000')}
 {inp('Email','email','email@example.com','email')}
 {sel('Lead Source','source',SOURCES.map(s=>({v:s.id,l:`${s.icon} ${s.name}`})))}
 {sel('Event Type','type',['Corporate','Wedding','School Picnic','Social Event','MICE / Conference','Birthday Party','Other'])}
 {inp('No. of Pax','pax','100','number')}
 {inp('Event Date','eventDate','','date')}
 {inp('Budget (₹)','budget','500000','number')}
 {sel('Status','status',['Hot','Warm','Cold'])}
 {inp('Assigned To','assignedTo','Pooja Rawat')}
 {inp('Follow-up Date','followUp','','date')}
 </div>
 <div style={{marginBottom:16}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>Notes</div>
 <textarea value={f.notes} onChange={e=>u('notes')(e.target.value)} rows={3} placeholder="Requirements, source, special requests..."
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:9,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',resize:'none',boxSizing:'border-box'}}/>
 </div>
 <div style={{display:'flex',gap:10}}>
 <Btn onClick={()=>{if(!f.name||!f.phone)return alert('Name and phone required');onSave({...f,id:Date.now(),pax:parseInt(f.pax)||100,budget:parseFloat(f.budget)||0,createdAt:today,venues:[],advancePaid:0,foodItems:[]});}} style={{flex:1,justifyContent:'center',fontSize:14,padding:'11px'}}> Save Lead</Btn>
 <Btn v="ghost" onClick={onClose} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </div>
 </div>
 </div>
 );
}

// ── MAIN ──────────────────────────────────────────────────────────────────────
const TABS=[
 {id:'dashboard',label:'Dashboard', },
 {id:'leads', label:'All Leads', },
 {id:'pipeline', label:'Pipeline', },
 {id:'venues', label:'Venue Manager',},
];

export default function SalesCRM() {
 const [tab,setTab]=useState('dashboard');
 const [leads,setLeads]=useState(LEADS);
 const [venues,setVenues]=useState(DEFAULT_VENUES);
 const [active,setActive]=useState(null);
 const [showNew,setShowNew]=useState(false);

 const upd=useCallback((id,k,v)=>{
 setLeads(p=>p.map(l=>l.id===id?{...l,[k]:v}:l));
 setActive(p=>p&&p.id===id?{...p,[k]:v}:p);
 },[]);

 const hot=leads.filter(l=>l.status==='Hot').length;
 const ft=leads.filter(l=>l.followUp===today&&!['Lost','Won'].includes(l.status)).length;

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text,background:C.bg,minHeight:'100vh'}}>
 {active&&<LeadPanel lead={active} onClose={()=>setActive(null)} onUpdate={upd} venues={venues} allLeads={leads}/>}
 {showNew&&<NewLead onSave={l=>{setLeads(p=>[l,...p]);setShowNew(false);}} onClose={()=>setShowNew(false)}/>}

 {/* Sticky Header */}
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50,boxShadow:'0 2px 8px rgba(0,0,0,.06)'}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:64}}>
 <div>
 <div style={{fontSize:10,color:C.text3,fontWeight:600,textTransform:'uppercase',letterSpacing:'.08em',marginBottom:2}}>Sales & Business Development</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:C.text,letterSpacing:'-.03em'}}>Sales CRM</div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 {hot>0&&<div style={{padding:'7px 14px',background:C.redBg,borderRadius:10,border:`1px solid ${C.redBorder}`,display:'flex',alignItems:'center',gap:6}}><span style={{fontSize:16}}></span><span style={{fontSize:12,fontWeight:700,color:C.red}}>{hot} Hot</span></div>}
 {ft>0&&<div style={{padding:'7px 14px',background:C.amberBg,borderRadius:10,border:`1px solid ${C.amberBorder}`,display:'flex',alignItems:'center',gap:6}}><span style={{fontSize:16}}></span><span style={{fontSize:12,fontWeight:700,color:C.amber}}>{ft} Follow-ups</span></div>}
 <Btn onClick={()=>setShowNew(true)} style={{fontSize:13}}>+ New Lead</Btn>
 </div>
 </div>
 <div style={{display:'flex',gap:0,borderTop:`1px solid ${C.border}`}}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'11px 22px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`3px solid ${tab===t.id?C.accent:'transparent'}`,display:'flex',alignItems:'center',gap:6,transition:'all .15s'}}>
 {t.icon} {t.label}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>
 {tab==='dashboard'&&<Dashboard leads={leads} venues={venues} onOpen={setActive}/>}
 {tab==='leads'&&(
 <div style={{display:'flex',flexDirection:'column',gap:12}}>
 <div style={{display:'flex',justifyContent:'flex-end',marginBottom:4}}>
 <Btn onClick={()=>setShowNew(true)} style={{fontSize:13}}>+ Add Lead</Btn>
 </div>
 {leads.map(l=><LeadCard key={l.id} lead={l} onClick={()=>setActive(l)}/>)}
 </div>
 )}
 {tab==='pipeline'&&<Pipeline leads={leads} onOpen={setActive}/>}
 {tab==='venues'&&<VenueManager venues={venues} setVenues={setVenues}/>}
 </div>
 </div>
 );
}
